import React from 'react';
import { cn } from './lib/utils';
import { Button } from './button';

/*
    Sticky bar header — port of `~co/common/header`.
    Subcomponents are namespaced (HeaderTitle vs form Title).
*/
export const Header = React.forwardRef(function Header(
  { as = 'div', className = '', ...etc },
  forwardedRef,
) {
  const Component = as;

  return (
    <Component
      ref={forwardedRef}
      className={cn('ui-header', className)}
      {...etc}
    />
  );
});

export function HeaderTitle({ className = '', ...etc }) {
  return <div className={cn('ui-header-title', className)} {...etc} />;
}

export function HeaderSpace() {
  return <div className='ui-header-space' />;
}

export function HeaderFirstAction({ className = '', ...etc }) {
  return (
    <div className={cn('ui-header-first-action', className)} {...etc} />
  );
}

export function HeaderLastAction({ className = '', ...etc }) {
  return (
    <div className={cn('ui-header-last-action', className)} {...etc} />
  );
}

export function HeaderSpaceAction(props) {
  return (
    <Button disabled {...props}>
      <div className='ui-header-space-action-icon' />
    </Button>
  );
}
